"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cn = cn;
const clsx_1 = require("clsx");
const tailwind_merge_1 = require("tailwind-merge");
/**
 * Join class names, letting a later one override an earlier one.
 *
 * ⚠️ **`twMerge` resolves CONFLICTS by group, and a custom utility it does not recognise is
 * a group it cannot resolve.** The outgoing project put its typography roles on `text-*`,
 * which is `tailwind-merge`'s font-size group, so `text-body text-foreground` returned only
 * `text-foreground` — the role silently discarded, in some four hundred places, for three
 * sightings before anybody noticed.
 *
 * Nothing here needs an extended configuration yet, because C1 adds no custom utilities. The
 * moment one arrives — a type role, a spacing token, anything on a prefix Tailwind already
 * owns — it must be declared to `twMerge` with a test, and the test must assert the role
 * SURVIVES beside a colour rather than that the function returns a string.
 */
function cn(...inputs) {
    return (0, tailwind_merge_1.twMerge)((0, clsx_1.clsx)(inputs));
}
//# sourceMappingURL=cn.js.map